var _defs, _mask, _linearGradient, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbmCloudAr21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "A",
    filterUnits: "userSpaceOnUse",
    x: 79.3,
    y: 86.2,
    width: 188.1,
    height: 166.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 79.3,
    y: 86.2,
    width: 188.1,
    height: 166.2,
    id: "B"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.4 152.5c-.6 0-1.2-.2-1.8-.5l-16.8-9.7c-1.6-.8-2.3-2.7-1.7-4.4.7-1.8 2.7-2.8 4.6-2.1l.6.3 16.8 9.7c1.7.9 2.4 3.1 1.5 4.8-.6 1.2-1.8 1.9-3.2 1.9zm29.1-29c-1.3 0-2.4-.7-3.1-1.8l-9.7-16.8c-.9-1.5-.6-3.5.7-4.7 1.5-1.3 3.7-1.1 5 .4.1.2.3.3.4.5l9.7 16.8c1 1.6.6 3.7-.9 4.9-.7.5-1.4.7-2.1.7zm36-14.4V90c0-2 1.4-3.6 3.4-3.8 2-.1 3.6 1.4 3.7 3.4v19.8c0 2-1.6 3.6-3.6 3.6h-.2c-1.8-.3-3.3-2-3.3-3.9zm43.2 14.4c-.7 0-1.4-.2-2-.6-1.5-1.1-1.9-3.3-.9-4.9l9.7-16.8c1-1.7 3.2-2.3 4.9-1.3.2.1.4.2.5.4 1.3 1.2 1.6 3.2.7 4.7l-9.7 16.8c-.7 1-1.9 1.7-3.2 1.7zm29 29c-1.3 0-2.5-.7-3.2-1.9-.8-1.8-.2-3.9 1.5-4.8l16.6-9.6c1.5-.9 3.4-.6 4.6.7 1.3 1.5 1.1 3.7-.4 5-.2.1-.3.3-.5.4l-17 9.8c-.3.2-.9.4-1.6.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 179.54,
    y1: 197.623,
    x2: 136.578,
    y2: 136.268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopOpacity: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128 233.7c-24.9-24.9-24.9-65.3 0-90.2s65.3-24.9 90.2 0a69.1 69.1 0 0 1 5.1 5.7c1.1 1.4 2.1 2.8 3.1 4.3l-5.9 3.9c-.9-1.3-1.8-2.6-2.8-3.8-1.4-1.8-2.9-3.5-4.5-5.1-22.1-22.1-58-22.1-80.2 0-22.1 22.1-22.1 58 0 80.2z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6 252.4h-98.2c-22.8-.2-41.1-18.7-40.9-41.5l7.1.1c-.1 18.8 15 34.2 33.8 34.4h98.1c23 0 41.6-18.6 41.7-41.6 0-10.2-3.8-20.1-10.6-27.8l5.3-4.7c17.9 20.1 16.2 50.9-3.8 68.8-9 7.9-20.5 12.3-32.5 12.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 75.254,
    y1: 203.618,
    x2: 118.48,
    y2: 178.661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.6 210.9l-7.1-.1c.1-20 14.6-37 34.3-40.3l1.2 7c-16.3 2.8-28.3 16.9-28.4 33.4z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 174.059,
    y1: 208.327,
    x2: 239.81,
    y2: 153.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopOpacity: 0.764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.9 203.3l-7.1-.1c.2-26.9 22.2-48.6 49.1-48.4 13.7.1 26.8 6 36 16.2l-5.3 4.7c-15.3-17.1-41.7-18.6-58.8-3.3-8.7 8-13.8 19.2-13.9 30.9z",
    fill: "url(#E)"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 234.367,
    y1: 65.613,
    x2: 120.164,
    y2: 259.491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ffd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.347 36.046v-1.008h1.414v-8.064h-1.414v-1.008h4.046v1.008H48.98v8.064h1.414v1.008zm6.258-10.08h4.144c1.666 0 2.688 1.022 2.688 2.604 0 1.498-.966 2.03-1.638 2.142v.084c.728.042 1.974.658 1.974 2.338 0 1.666-1.106 2.912-2.604 2.912H52.59zm1.204 4.354h2.786c.952 0 1.526-.504 1.526-1.4v-.5c0-.896-.574-1.4-1.526-1.4H53.81zm0 4.648h2.996c1.036 0 1.68-.546 1.68-1.554v-.5c0-1.008-.63-1.554-1.68-1.554H53.81zm16.058-7.42h-.07l-.854 1.694-2.408 4.396-2.394-4.396-.854-1.68h-.07v8.484h-1.2v-10.08H63.6l2.884 5.432h.056l2.898-5.432h1.582v10.08h-1.162zm6.076 3.528c0-3.402 1.75-5.292 4.466-5.292 1.848 0 3.038.756 3.766 2.366l-1.9.98c-.266-.84-.798-1.4-1.876-1.4-1.288 0-2.142.868-2.142 2.45v1.624c0 1.582.854 2.45 2.142 2.45 1.078 0 1.708-.672 2.002-1.498l1.792 1.036c-.756 1.526-1.946 2.408-3.794 2.408-2.716.014-4.466-1.722-4.466-5.124zm11.802 4.97c-1.456 0-2.128-.742-2.128-2.086v-8.6h2.142v9.03h.952v1.666zm1.778-3.808c0-2.436 1.33-3.962 3.556-3.962s3.556 1.512 3.556 3.962c0 2.436-1.33 3.976-3.556 3.976s-3.556-1.526-3.556-3.976zm4.886.784v-1.54c0-.952-.5-1.498-1.33-1.498s-1.33.546-1.33 1.498v1.54c0 .952.5 1.498 1.33 1.498s1.33-.546 1.33-1.498zm8.218 1.75h-.07c-.266.77-.882 1.442-2.128 1.442-1.54 0-2.366-1.078-2.366-2.996v-4.76h2.142v4.578c0 .924.308 1.442 1.078 1.442.658 0 1.344-.378 1.344-1.092v-4.928h2.142v7.588h-2.142zm8.778 0h-.07c-.2.826-1.05 1.442-2.03 1.442-1.918 0-2.912-1.4-2.912-3.976s.994-3.962 2.912-3.962c.98 0 1.82.602 2.03 1.442h.07v-4.382h2.142v10.682h-2.142zm0-1.4v-2.24c0-.7-.588-1.106-1.4-1.106s-1.4.616-1.4 1.568V32.9c0 .952.588 1.568 1.4 1.568s1.4-.42 1.4-1.106z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.174633 0 0 .164594 -7.396642 1.227934)",
    mask: "url(#B)",
    d: "M79.3 86.2h188.1v166.2H79.3z",
    fill: "url(#F)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmCloudAr21);
export default __webpack_public_path__ + "static/media/ibm_cloud-ar21.b104b62b904d64ac9a757625e18f736e.svg";
export { ForwardRef as ReactComponent };